import { DEFAULT_NOMINATION, GROUP_NAMES, SUBORDINATION_TRANSFER_REQUEST_TYPE, SUBORDINATION_TRANSFER_STATUS, SUBORDINATION_TRANSFER_STATUS_DATA } from '@/modules/Events/constants';
import User from './user';
import { DEFAULT_NAME_GROUP } from './group';

export default class ParticipantSubordinated extends User {
  constructor(item, url) {
    super(item, url);

    this.id = item.id;
    this.user_name = item.user_name;
    this.snils = item.snils;
    this.score = item.score;
    this.final_score = item.final_score;
    this.final_result = item.final_result;
    this.status = item.status;

    this.nomination_id = item.nomination_id;
    this.nomination_name = item.nomination_name;

    this.group_id = item.group_id;
    this.parent_group_id = item.parent_group_id;
    this.group_name = item.group_name;

    this.tournament_stage_group_id = item.tournament_stage_group_id;
    this.tournament_stage_group_name = item.tournament_stage_group_name;
    this.tournament_id = item.tournament_id;
    this.tournament_name = item.tournament_name;

    this.event_id = item.event_id;
    this.event_name = item.event_name;

    this.organization_id = item.organization_id;
    this.organization_name = item.organization_name;

    this.event_subordination_id = item.event_subordination_id;
    this.event_subordination_status = item.event_subordination_status ?? null;
    this.is_force_transfer = item.is_force_transfer ?? false;
    this.event_subordination_group_id = item.event_subordination_group_id || null; // куда перевёл с нижестоящего
    this.event_subordination_request = item.event_subordination_request || null;
  }

  get pendingRequest() {
    return this.event_subordination_request?.status === SUBORDINATION_TRANSFER_STATUS.new
      ? this.event_subordination_request : null;
  }

  get canTransfer() {
    return !this.event_subordination_status || this.event_subordination_status === SUBORDINATION_TRANSFER_STATUS.reject;
  }

  canActOnPendingRequest(requestType, permission) {
    return this.event_subordination_status === SUBORDINATION_TRANSFER_STATUS.new
      && this.pendingRequest?.request_type === requestType
      && this.pendingRequest[permission] === true;
  }

  get canApproveRequest() {
    return this.canActOnPendingRequest(SUBORDINATION_TRANSFER_REQUEST_TYPE.push, 'can_approve');
  }

  get canRejectRequest() {
    return this.canActOnPendingRequest(SUBORDINATION_TRANSFER_REQUEST_TYPE.push, 'can_reject');
  }

  get canCancelRequest() {
    return this.canActOnPendingRequest(SUBORDINATION_TRANSFER_REQUEST_TYPE.pullRequest, 'can_cancel');
  }

  get displayNominationName() {
    return this.nomination_name === DEFAULT_NOMINATION.KEY ? DEFAULT_NOMINATION.NAME : this.nomination_name;
  }

  get displayGroupName() {
    return this.group_name === GROUP_NAMES.default ? DEFAULT_NAME_GROUP : this.group_name;
  }

  get subordinationStatusData() {
    const { event_subordination_status } = this;
    if (!event_subordination_status) return null;
    return {
      ...SUBORDINATION_TRANSFER_STATUS_DATA[event_subordination_status],
      isConfirm: event_subordination_status === SUBORDINATION_TRANSFER_STATUS.confirm,
      isNew: event_subordination_status === SUBORDINATION_TRANSFER_STATUS.new,
      isReject: event_subordination_status === SUBORDINATION_TRANSFER_STATUS.reject,
    };
  }
}
